
<!--
 * @Author:
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-28 14:13:03
 * @Description: 日行一善s
-->
<template>
  <div style="background: rgb(246, 248, 251);height: 100vh;width: 100%;">
      <el-container>
        <el-aside width="180px">
          <el-tabs tab-position="left" style="height: 100%;" @tab-click="change_tab" v-model="tabActive">
            <el-tab-pane label="统计看板" name="0"> </el-tab-pane>
            <el-tab-pane label="发布统计" name="1"> </el-tab-pane>
            <el-tab-pane label="学习榜样排名" name="2"> </el-tab-pane>
            <el-tab-pane label="全部帖子" name="3"> </el-tab-pane>
            <el-tab-pane label="博士日行一善" name="4"> </el-tab-pane>
            <el-tab-pane label="我的动态" name="5"> </el-tab-pane>
            <el-tab-pane label="AI动态分析" name="6"> </el-tab-pane>
          </el-tabs>
        </el-aside>
        <el-main class="mainContent" style="height: 100vh;">
          <div>
            <el-breadcrumb separator="/" style="margin-top: 10px;" v-if="allDetails&&docDetails&&myDetails">
              <el-breadcrumb-item v-for="(item,index) in tabRlact[tabActive]" :key="index">{{ item }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="border-bottom: 2px solid rgb(246, 248, 253);width: 100%;margin: 10px 0;"></div>
            <div v-if="tabActive == '0'">
              <Statistical style="margin-bottom: 15px;"/>
              <ManagerLike/>
            </div>
            <div v-if="tabActive == '1'">
              <PublishStatistics/>
            </div>
            <div v-if="tabActive == '2'">
              <AwardRanking/>
            </div>
            <div v-if="tabActive == '3'">
              <AllPost v-if="allDetails" :allDetails.sync="allDetails" :logId.sync = logId   />
              <GoodPostDetail :allDetails.sync="allDetails" :logId.sync = logId  v-else/>
            </div>
            <div v-if="tabActive == '4'">
              <CDoctorPost v-if="docDetails" :docDetails.sync="docDetails" :logId.sync = logId />
              <CmPostDetail :docDetails.sync="docDetails" :logId.sync = logId  v-else/>
            </div>
            <div v-if="tabActive == '5'">
              <MyPost v-if="myDetails" :myDetails.sync="myDetails" :logId.sync = logId />
              <MyPostDetail :myDetails.sync="myDetails" :logId.sync = logId  v-else/>
            </div>
            <div v-if="tabActive == '6'">
              <AiDynamicAnalysis />
            </div>
          </div>
        </el-main>
      </el-container>
  </div>
</template>

<script>
import Statistical from "@/components/OneGoodModule/Statistical";
import ManagerLike from "@/components/OneGoodModule/ManagerLike";
import PublishStatistics from "@/components/OneGoodModule/PublishStatistics";
import AwardRanking from "@/components/OneGoodModule/AwardRanking"
import AllPost from "@/components/OneGoodModule/AllPost"
import CDoctorPost from "@/components/OneGoodModule/CDoctorPost"
import GoodPostDetail from "@/components/OneGoodModule/GoodPostDetail"
import CmPostDetail from "@/components/OneGoodModule/CmPostDetail"
import MyPostDetail from "@/components/OneGoodModule/MyPostDetail"
import MyPost from "@/components/OneGoodModule/MyPost"
import AiDynamicAnalysis from "@/components/OneGoodModule/AiDynamicAnalysis"
export default {
  name: "DoOneGood",
  components: { Statistical,ManagerLike,PublishStatistics, AwardRanking,AllPost,CDoctorPost,MyPost,GoodPostDetail,CmPostDetail,MyPostDetail,AiDynamicAnalysis},
  data() {
    return {
      tabRlact:{
        '0':['日行一善','统计看板'],
        '1':['日行一善','发布统计'],
        '2':['日行一善','学习榜样排名'],
        '3':['日行一善','全部帖子'],
        '4':['日行一善','博士日行一善'],
        '5':['日行一善','我的动态'],
        '6':['日行一善','AI动态分析'],

      },
      tabActive:'0',
      allDetails:true,
      docDetails:true,
      myDetails:true,
      logId:null
    };
  },
  methods: {
    change_tab(val) {
      this.allDetails = true
      this.docDetails = true
      this.myDetails = true
      this.tabActive = val.name
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.middle {
  vertical-align: middle;
  /* height: 31px; */
  width: 126px;
  height: 50px;
}
.mainContent {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/DoOneGood.vue